import React from "react";
import PropTypes from "prop-types";
import EditContainer from "../../layouts/edit-container";
import MarkdownButtonsList from "./markdown-buttons-list";
import MarkdownHelper from "../../../helpers/markdown";

class EditNoteContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editedNoteText: this.props.noteText,
      mode: this.props.noteText === "" ? "add" : "edit"
    };

    // this._autoSizeNote = this._autoSizeNote.bind(this);
    this._onNoteChange = this._onNoteChange.bind(this);
    this._onKeyUp = this._onKeyUp.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onCancel = this._onCancel.bind(this);
    this._onSave = this._onSave.bind(this);
    this._onMarkdownButtonClick = this._onMarkdownButtonClick.bind(this);
    this._forceUpdate = this._forceUpdate.bind(this);
  }

  componentDidMount() {
    this._autoSizeNote();

    // Not sure why this timeout is needed, but focus doesn't work without it.
    setTimeout(() => {
      this.props.openCallback();
      this._autoSizeNote();

      const note = this.note;
      note.focus();

      // This should set the cursor to the end of the textarea.
      const value = note.value;
      note.value = value;
    }, 0);
  }

  componentDidUpdate() {
    this._autoSizeNote();
  }

  _autoSizeNote() {
    if (this.note) {
      $(this.note)
        .autosize({ append: false })
        .trigger("autosize.resize");
    }
  }

  // Event handlers

  _onNoteChange(e) {
    this.setState({
      editedNoteText: e.currentTarget.value
    });
  }

  _onKeyDown(e) {
    MarkdownHelper._list(
      e,
      this.note,
      this.state.editedNoteText,
      this._onMarkdownButtonClick
    );
  }

  _onKeyUp(e) {
    e.stopPropagation();
  }

  _onCancel() {
    Fraction.Helpers.removeModal();
    this.props.cancelCallback();
  }

  _onSave() {
    Fraction.Helpers.removeModal();
    this.props.saveCallback(this.state.editedNoteText);
  }

  _onMarkdownButtonClick(noteText, start, end) {
    this.setState({ editedNoteText: noteText }, () => {
      this.note.selectionStart = start;
      this.note.selectionEnd = end;
      this.note.focus();
    });
  }

  _forceUpdate() {
    this.forceUpdate();
  }

  render() {
    const title = i18n.t("reader.notebook." + this.state.mode + "-note");

    return (
      <EditContainer
        title={title}
        leftHeader={i18n.t("base.cancel")}
        rightHeader={i18n.t("base.save")}
        cancelEditCallback={this._onCancel}
        saveEditCallback={this._onSave}
      >
        <div className="notecard">
          <div className="notecard-header">
            <div className="left">
              <div className="marker-name">{this.props.markerLabel}</div>
            </div>
            <div className="right">
              <div className="last-modified">
                {this.props.lastModifiedString}
              </div>
            </div>
          </div>
          <div className="highlight">
            <div
              className="highlight-text"
              style={{ background: this.props.highlightColor }}
            >
              {this.props.highlightText}
            </div>

            <MarkdownButtonsList
              onChange={this._onMarkdownButtonClick}
              selectionStart={this.note && this.note.selectionStart}
              selectionEnd={this.note && this.note.selectionEnd}
              note={this.state.editedNoteText}
            />
            <textarea
              ref={note => {
                this.note = note;
              }}
              rows="1"
              className="note"
              placeholder={i18n.t("reader.notebook.add-note")}
              defaultValue={this.state.editedNoteText}
              value={this.state.editedNoteText}
              onChange={this._onNoteChange}
              onKeyUp={this._onKeyUp}
              onClick={this._forceUpdate}
              onKeyDown={this._onKeyDown}
            />
          </div>
        </div>
      </EditContainer>
    );
  }
}

EditNoteContainer.propTypes = {
  markerLabel: PropTypes.string,
  lastModifiedString: PropTypes.string,
  noteText: PropTypes.string,
  highlightColor: PropTypes.string,
  openCallback: PropTypes.func,
  cancelCallback: PropTypes.func,
  saveCallback: PropTypes.func
};

EditNoteContainer.defaultProps = {
  noteText: "",
  markerLabel: "",
  lastModifiedString: "",
  highlightColor: ""
};

module.exports = EditNoteContainer;
